import { MESSAGES } from 'src/modules/common/constants.ts';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { Selection } from 'src/projects/types/Selection.ts';
import { createReduceSelections } from 'src/projects/utils/createReduceSelections.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { WorkSheet } from 'src/projects/hooks/composeExcelBuffer.ts';

export const exportSelection = ({
    selection,
    userSettings,
    t,
}: {
    selection: Selection;
    t: BelimoTranslate;
    userSettings: UserSettings;
}) => {
    const reduceSelection = createReduceSelections({ userSettings, t });
    const data: { actuators: WorkSheet; sensors: WorkSheet; valves: WorkSheet } = {
        actuators: { columns: [], rows: [], name: t(MESSAGES.Actuators) },
        sensors: { columns: [], rows: [], name: t(MESSAGES.Sensors) },
        valves: { columns: [], rows: [], name: t(MESSAGES.Valves) },
    };
    switch (selection.type) {
        case 'retrofit_actuators':
        case 'actuators': {
            return {
                ...data,
                actuators: [selection].reduce(reduceSelection, data.actuators),
            };
        }
        case 'retrofit_sensors':
        case 'sensors': {
            return {
                ...data,
                sensors: [selection].reduce(reduceSelection, data.sensors),
            };
        }
        case 'retrofit_valves':
        case 'valves': {
            return {
                ...data,
                valves: [selection].reduce(reduceSelection, data.valves),
            };
        }
        default: {
            return data;
        }
    }
};
